import AddPostContainer from 'modules/posts/containers/AddPostContainer';

const AddPostView = () => <AddPostContainer />;

export default AddPostView;
